import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Typography } from '@mui/material';

const PageNotFound = () => (
    <>
        <Helmet>
            <title>Page Not Found - DevX Infra</title>
        </Helmet>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '500px' }}>
            <Typography variant="h3" color="text.secondary">
                404 | Page Not Found
            </Typography>
        </Box>
    </>
);

export default PageNotFound;
